import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ElevationStats, Lookups, Waypoint} from "@model";
import {AbstractComponent} from "../abstract.component";
import {TranslocoService} from "@ngneat/transloco";
import {waypointTypeIcons} from "../../model/waypoint-type-icons";

@Component({
    selector: 'app-race-profile-modal',
    templateUrl: './race-profile-modal.component.html',
    styleUrl: './race-profile-modal.component.scss',
    standalone: false
})
export class RaceProfileModalComponent extends AbstractComponent {
  @Input() waypoint: Waypoint | undefined;
  @Input() previousWaypoint: Waypoint | undefined;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() elevationStats: ElevationStats | undefined

  constructor(public activeModal: NgbActiveModal, public translocoService: TranslocoService) {
    super();
  }

  waypointTypeIcons: { [key: number]: string } = waypointTypeIcons;

  onDismissClick(): void {
    this.activeModal.dismiss();
  }
}
